'use strict'

const th = function extractTensAndHundreds (checkFunction) {
  return function (value) {
    const tens = value % 10
    const hundreds = value % 100
    return checkFunction(tens, hundreds)
  }
}

module.exports = [
  { suffix: 'st', if: th((tens, hundreds) => tens === 1 && hundreds !== 11) },
  { suffix: 'nd', if: th((tens, hundreds) => tens === 2 && hundreds !== 12) },
  { suffix: 'rd', if: th((tens, hundreds) => tens === 3 && hundreds !== 13) },
  { suffix: 'th' }
]
